module.exports = __webpack_public_path__ + "static/img/camp1.3b84d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp1.jpg
// module id = BHnW
// module chunks = 0